import { useState } from 'react';
import { Send } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface MessageInputProps {
  disabled: boolean;
  placeholder?: string;
  onSend?: (message: string) => void;
}

export function MessageInput({
  disabled,
  placeholder = 'Digite uma mensagem...',
  onSend,
}: MessageInputProps) {
  const [value, setValue] = useState('');

  function handleSend() {
    if (disabled || !value.trim()) return;
    onSend?.(value.trim());
    setValue('');
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  }

  const inputElement = (
    <div className="flex gap-2">
      <Input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={disabled ? 'Somente leitura' : placeholder}
        disabled={disabled}
        className="flex-1"
      />
      <Button
        onClick={handleSend}
        disabled={disabled || !value.trim()}
        size="icon"
        aria-label="Enviar mensagem"
      >
        <Send className="h-4 w-4" />
      </Button>
    </div>
  );

  if (disabled) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="cursor-not-allowed">{inputElement}</div>
          </TooltipTrigger>
          <TooltipContent>
            Conversas reais são somente leitura
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return inputElement;
}
